<template>
    <input type="hidden" :value="value" />
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'HiddenField',
    mixins: [FieldMixin]
}
</script>
